import React, { useRef, useState } from 'react';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import '../../../style.css';
import { Link } from 'react-router-dom';
import labelsData from '../../../labels.json';
import { createSlug } from '../../../createSlug';
import Animations from '../../../Animations';

const Metrics = ({ dynamicContent }) => {
    const sectionRef = useRef(null);
    const [contentLoaded, setContentLoaded] = useState(false);

    const currentSlug = window.location.pathname.split('/').pop();
    const currentIndex = labelsData.findIndex(item => createSlug(item.title) === currentSlug);
    const prevIndex = (currentIndex - 1 + labelsData.length) % labelsData.length;
    const nextIndex = (currentIndex + 1) % labelsData.length;

    const prevTemplate = labelsData[prevIndex].template;
    const nextTemplate = labelsData[nextIndex].template;

    const prevSlug = `${prevTemplate}/${createSlug(labelsData[prevIndex].title)}`;
    const nextSlug = `${nextTemplate}/${createSlug(labelsData[nextIndex].title)}`;

    const handleIntersection = () => {
        setContentLoaded(true);
    };

    const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

    const renderMetricsList = (metrics) => {
        if (!metrics) return null; // Guard against undefined metrics

        return (
            <ul className="stats-list metrics">
                {metrics.map((metric, index) => (
                    <Animations type="fadeInUp" delay={`${index * 0.5}s`} key={`stat${index}`}>
                        <li>
                            <div className="stats-card">
                                <div className="card-icon">
                                    <ion-icon name={metric.icon}></ion-icon>
                                </div>
                                <h2 className="h2 card-title">
                                    {metric.value}
                                    <strong>{metric.text}</strong>
                                </h2>
                            </div>
                        </li>
                    </Animations>
                ))}
            </ul>
        );
    };

    // If dynamicContent or any of its metrics are not available, render a loading state
    if (!dynamicContent || !dynamicContent.Metric1 || !dynamicContent.Metric2 || !dynamicContent.Metric3) {
        return <div className="loading-container loading-spinner-container">Loading...</div>;
    }

    return (
        <div ref={sectionRef} className={`loading-container${contentLoaded ? '' : ' loading-spinner-container'}`}>
            {contentLoaded ? (
                <section className={`stats${isVisible ? ' fade-in-observer' : ''}`} id="stats">
                    {/* Render dynamic metrics here */}
                    {renderMetricsList([
                        { icon: dynamicContent.Metric1[0], value: dynamicContent.Metric1[1], text: dynamicContent.Metric1[2] },
                        { icon: dynamicContent.Metric2[0], value: dynamicContent.Metric2[1], text: dynamicContent.Metric2[2] },
                        { icon: dynamicContent.Metric3[0], value: dynamicContent.Metric3[1], text: dynamicContent.Metric3[2] }
                    ])}

                    {/* Navigation buttons */}
                    <div className="footer-navigation">
                        <div className="navigation-item-l">
                            <Link to={`/portfolio/${prevSlug}`} className="go-left-footer" title="Previous Portfolio Entry">
                                <ion-icon name="chevron-back-outline"></ion-icon>
                                <span className="navigation-text">({prevTemplate}) {labelsData[prevIndex].title}</span>
                            </Link>
                        </div>
                        <div className="navigation-item-r">
                            <Link to={`/portfolio/${nextSlug}`} className="go-right-footer" title="Next Portfolio Entry">
                                <span className="navigation-text">({nextTemplate}) {labelsData[nextIndex].title}</span>
                                <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                        </div>
                    </div>
                </section>
            ) : (
                <div className="observer_spinner"></div>
            )}
        </div>
    );
};

export default Metrics;
